import script from "./talentView.vue?vue&type=script&setup=true&lang=ts"
export * from "./talentView.vue?vue&type=script&setup=true&lang=ts"

import "./talentView.vue?vue&type=style&index=0&id=4acc1807&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4acc1807"]])

export default __exports__